@if (loading.visible()) {
  <div class="loading-bar" role="progressbar" aria-label="Loading" aria-valuetext="Loading"></div>
}
